<template>
    <div class="flex flex-col flex-wrap items-start gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex flex-col flex-wrap items-start gap-3 sm:flex-row sm:items-center">
            <BaseButton theme="tertiary" size="sm" type="button" data-testid="wrong-person-button" class="flex items-center gap-2" @click="emit('wrong-person')">
                <i class="bi bi-question-circle text-xs/none" aria-hidden="true"></i>
                Wrong person?
            </BaseButton>
            <BaseButton v-if="showDirectorySearch" theme="tertiary" size="sm" type="button" @click="emit('directory-search')"> Already in my people </BaseButton>
        </div>
        <BaseButton theme="tertiary" size="sm" type="button" class="flex items-center gap-2" @click="emit('decline')">
            <i class="bi bi-x text-lg/none" aria-hidden="true"></i>
            Not a person
        </BaseButton>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";

type Props = {
    showDirectorySearch?: boolean;
};

const { showDirectorySearch = false } = defineProps<Props>();

const emit = defineEmits<{
    "wrong-person": [];
    "directory-search": [];
    decline: [];
}>();
</script>
